
export const AddSvg = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.99984 2.66663C8.36803 2.66663 8.6665 2.9651 8.6665 3.33329V7.33329H12.6665C13.0347 7.33329 13.3332 7.63177 13.3332 7.99996C13.3332 8.36815 13.0347 8.66663 12.6665 8.66663H8.6665V12.6666C8.6665 13.0348 8.36803 13.3333 7.99984 13.3333C7.63165 13.3333 7.33317 13.0348 7.33317 12.6666V8.66663H3.33317C2.96498 8.66663 2.6665 8.36815 2.6665 7.99996C2.6665 7.63177 2.96498 7.33329 3.33317 7.33329H7.33317V3.33329C7.33317 2.9651 7.63165 2.66663 7.99984 2.66663Z" fill="#4A5565" />
        </svg>

    )
}